import { render, staticRenderFns } from "./ImportPropertiesComponent.vue?vue&type=template&id=179a7183&scoped=true"
import script from "./ImportPropertiesComponent.vue?vue&type=script&lang=js"
export * from "./ImportPropertiesComponent.vue?vue&type=script&lang=js"
import style0 from "./ImportPropertiesComponent.vue?vue&type=style&index=0&id=179a7183&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179a7183",
  null
  
)

export default component.exports